module.exports = __webpack_public_path__ + "static/media/hollow_bar_prewash.38ce8cb3.svg";